import axios from 'axios';
import requestInterceptor from './requestInterceptor';
import errorResponseInterceptor from './errorResponseInterceptor';

const defaultMimeType = 'application/json';

const axiosApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
axiosApiInstance.interceptors.request.use(requestInterceptor);
axiosApiInstance.interceptors.response.use(null, errorResponseInterceptor);

export default axiosApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/index.js